import React, {PureComponent} from 'react';
import {inject, observer} from 'mobx-react';
import {ArticlesStore} from 'app/store/ArticlesStore';
import {newsArticles, promotionArticles} from 'app/utils';
import LetsShow from 'app/components/pages/LetsShow';

interface LetsShowHomeProps {
    articlesStore?: ArticlesStore
}

@inject('articlesStore')
@observer
export default class LetsShowHome extends PureComponent<LetsShowHomeProps> {
    render(): React.ReactNode {
        const {articlesStore} = this.props;
        return <LetsShow
            loadArticles={articlesStore.loadMainArticles}
            data_left={newsArticles(articlesStore.homePageArticles)}
            type_left="news"
            nameForControls_left="news"
            data_right={promotionArticles(articlesStore.homePageArticles)}
            type_right="promotions"
            nameForControls_right="promotions"
        />;
    }
}
